import qs from "query-string";
import useUi from "../models/ui/useUi";
import useAuth from "../models/auth/useAuth";

const stringify = qs.stringify;

const useFetch = () => {
  const { showLoader, hideLoader } = useUi();
  const { logout } = useAuth();
  const baseUrl = process.env.REACT_APP_API;

  const getHeaders = (isPrivate, isMultipart) => {
    const headers = isMultipart
      ? {}
      : {
          "Content-Type": "application/json",
          Accept: "application/json",
        };
    if (!isPrivate) {
      return headers;
    }
    return {
      ...headers,
      Authorization: `Bearer ${localStorage.wubalu_restaurants_access_token}`,
    };
  };

  const responseHandler = async (response) => {
    try {
      const res = await response.json();
      if (response.status.toString()[0] !== "2") {
        throw res;
      } else {
        return res;
      }
    } catch (e) {
      if (response.status === 401) logout();
      throw response;
    }
  };

  const get = async ({ endpoint, params, isPrivate, preventLoader }) => {
    const url = `${baseUrl}/${endpoint}${
      params ? `?${stringify(params)}` : ""
    }`;
    !preventLoader && showLoader();
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: getHeaders(isPrivate),
      });
      const parsedResponse = await responseHandler(response);
      return parsedResponse;
    } catch (e) {
      throw e;
    } finally {
      !preventLoader && hideLoader();
    }
  };

  const post = async ({ endpoint, body, isPrivate = true, isMultipart }) => {
    const url = `${baseUrl}/${endpoint}`;
    showLoader();
    try {
      const response = await fetch(url, {
        body: isMultipart ? body : JSON.stringify(body),
        method: "POST",
        headers: getHeaders(isPrivate, isMultipart),
      });
      const parsedResponse = await responseHandler(response);
      return parsedResponse;
    } catch (e) {
      throw e;
    } finally {
      hideLoader();
    }
  };

  const put = async ({ endpoint, id, body, isPrivate = true, isMultipart }) => {
    const url = `${baseUrl}/${endpoint}/${id}`;
    showLoader();
    try {
      const response = await fetch(url, {
        body: isMultipart ? body : JSON.stringify(body),
        method: "PUT",
        headers: getHeaders(isPrivate),
      });
      const parsedResponse = await responseHandler(response);
      return parsedResponse;
    } catch (e) {
      throw e;
    } finally {
      hideLoader();
    }
  };

  const patch = async ({ endpoint, id, body, isPrivate, isMultipart }) => {
    const url = `${baseUrl}/${endpoint}/${id}`;
    showLoader();
    try {
      const response = await fetch(url, {
        body: isMultipart ? body : JSON.stringify(body),
        method: "PATCH",
        headers: getHeaders(isPrivate, isMultipart),
      });
      const parsedResponse = await responseHandler(response);
      return parsedResponse;
    } catch (e) {
      throw e;
    } finally {
      hideLoader();
    }
  };

  const del = async ({ endpoint, id, isPrivate = true }) => {
    const url = `${baseUrl}/${endpoint}/${id}`;
    showLoader();
    try {
      return await fetch(url, {
        method: "DELETE",
        headers: getHeaders(isPrivate),
      });
    } catch (e) {
      throw e;
    } finally {
      hideLoader();
    }
  };

  return {
    get,
    post,
    put,
    patch,
    del,
  };
};

export default useFetch;
